import type { ReactNode } from 'react'

/**
 * A slim line above the mirror while a recording is on its way (Sprint 1.9.9).
 *
 * It replaces the overview's "Upload started" card and keeps its words: the
 * eyebrow and the sentence are the card's own when this browser started the
 * upload, and "Open Record" goes where the job is followed. With no pointer —
 * a job `/home` reports that another tab or device started — it says only that
 * one is being processed. Nothing here polls; Record does.
 */
export function ProcessingBanner({
  eyebrow,
  sentence,
  action,
}: {
  eyebrow: string | null
  sentence: string
  action?: ReactNode
}) {
  return (
    <div className="home-banner" data-testid="processing-banner">
      {eyebrow !== null && <span className="home-banner__eyebrow">{eyebrow}</span>}
      <span className="home-banner__text">{sentence}</span>
      {action}
    </div>
  )
}
